<template>
  <header v-if="loggedIn && user" class="bg-white p-2 text-gray-700 text-center flex flex-col gap-2 sm:flex-row" style="justify-content: space-around;">
    <div class="flex items-center justify-center text-sm text-center gap-4">
      <p>{{ user.current_role }}</p>
      <p class="text-gray-900"><strong>{{ user.office_code }} - {{ user.name }}</strong></p>
      <p v-if="user.current_role !== 'Supplier'" class="text-xs text-gray-500 italic">(Wilayah Harga {{ getWilayah }})</p>
    </div>
    <div class="flex items-center justify-center flex-wrap text-sm text-center gap-x-2">
      <p>Periode <b class="text-gray-900">{{ currentPeriod.name }}</b></p>
      <p class="text-xs text-gray-500 italic">({{ startPeriod }} - {{ endPeriod }})</p>
    </div>
  </header>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { StorageService } from '../../services/storage.service';

export default {
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      currentPeriodType: 'auth/getCurrentPeriod'
    }),
    currentPeriod() {
      if (this.currentPeriodType === 'pusat') {
        return this.user.current_pusat_period
      }
      
      if (this.currentPeriodType === 'stockist') {
        return this.user.current_period
      }

      return this.user.current_order_period
    },
    getWilayah() {
      if (this.user.office_area_code === null) {
        return 'belum ditambahkan'
      }

      const list = ['Jawa', 'I', 'II', 'III', 'IV', 'loading...'];
      return list[this.user.office_area_code ?? 5];
    },
    loggedIn() {
      return StorageService.getLoginState()
    },
    startPeriod() {
      const date = dayjs(this.currentPeriod.start_date)
      const endOfMonth = date.isSame(date.endOf('month'), 'hour')

      return endOfMonth ? date.add('1', 'day').startOf('day').format('LL') : date.format('LL')
    },
    endPeriod() {
      if (this.currentPeriodType === 'pusat') {
        return dayjs(this.currentPeriod.pusat_end_date).format('LL')
      }

      return dayjs(this.currentPeriod.end_date).format('LL')
    }
  }
}
</script>